export class IngestionPipelineIssue {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "code",
            "baseName": "code",
            "type": "string",
            "format": ""
        },
        {
            "name": "severity",
            "baseName": "severity",
            "type": "IngestionPipelineIssueSeverity",
            "format": ""
        },
        {
            "name": "message",
            "baseName": "message",
            "type": "string",
            "format": ""
        },
        {
            "name": "value",
            "baseName": "value",
            "type": "number",
            "format": ""
        },
        {
            "name": "dimensions",
            "baseName": "dimensions",
            "type": "{ [key: string]: string; }",
            "format": ""
        },
        {
            "name": "lastConfirmedAt",
            "baseName": "lastConfirmedAt",
            "type": "Date",
            "format": "date-time"
        }
    ];
    static getAttributeTypeMap() {
        return IngestionPipelineIssue.attributeTypeMap;
    }
    constructor() {
    }
}
